/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import { Modal, Form, Input, Row, Col, Select, Button } from 'antd';
import { connect } from 'react-redux';

import { createHomeStat, editHomeStat } from '../../../../../../../actions';

class HomeStatModal extends Component {
  constructor(props) {
    super(props);
    const { initialValue } = props;
    this.state = {
      values: initialValue ? {
        title: initialValue.title || [],
        position: initialValue.position || 1,
        count: initialValue.count || 0,
        color: initialValue.color,
      } : {
        title: [{
          lang: 'vi',
          value: '',
        }],
        position: 1,
        count: 0,
        color: '#DEE4E8',
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { initialValue } = this.props;
    if (nextProps.initialValue !== initialValue) {
      this.setState({
        values: nextProps.initialValue ? {
          title: nextProps.initialValue.title || [],
          position: nextProps.initialValue.position || 1,
          count: nextProps.initialValue.count || 0,
          color: nextProps.initialValue.color,
        } : {
          title: [{
            lang: 'vi',
            value: '',
          }],
          count: 0,
          color: '#DEE4E8',
          position: 1,
        },
      });
    }
  }

  handleUpdateField = (field, value) => {
    const { values } = this.state;
    this.setState({
      values: {
        ...values,
        [field]: value,
      },
    });
  }

  handleSubmit = () => {
    const { values } = this.state;
    const { initialValue, createHomeStat, editHomeStat, onCancel } = this.props;
    if (!initialValue) {
      createHomeStat({ data: values,
        response: {
          success: () => {
            this.setState({
              values: {
                title: [{
                  lang: 'vi',
                  value: '',
                }],
                position: 1,
                count: 0,
                color: '#DEE4E8',
              },
            });
            onCancel();
          },
          failure: () => {},
        } });
    } else {
      editHomeStat({ _id: initialValue._id,
        data: values,
        response: {
          success: () => {
            this.setState({
              values: {
                title: [{
                  lang: 'vi',
                  value: '',
                }],
                position: 1,
                count: 0,
                color: '#DEE4E8',
              },
            });
            onCancel();
          },
          failure: () => {},
        } });
    }
  }

  render() {
    const { visible, initialValue, onCancel, loading } = this.props;
    const { values } = this.state;
    return (
      <Fragment>
        <Modal
          visible={visible}
          title={initialValue ? 'Cập nhật' : 'Thêm mới'}
          onCancel={onCancel}
          onOk={this.handleSubmit}
          confirmLoading={loading}
          maskClosable={false}
          centered
        >
          <Form.Item label="Tiêu đề">
            {values.title.map((item, index) => (
              <Row key={index} gutter={16} style={{ width: '100%', marginBottom: 10 }}>
                <Col sm={values.title.length > 1 ? 7 : 8}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Ngôn ngữ"
                    value={item.lang}
                    onChange={lang => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          lang,
                        }) : i)),
                      },
                    })}
                  >
                    <Select.Option value='vi' disabled={values.title.find((i, idx) => i.lang === 'vi' && idx !== index)}>Tiếng Việt</Select.Option>
                    <Select.Option value='en' disabled={values.title.find((i, idx) => i.lang === 'en' && idx !== index)}>Tiếng Anh</Select.Option>
                  </Select>
                </Col>
                <Col sm={16}>
                  <Input
                    style={{ width: '100%' }}
                    placeholder="Giá trị"
                    value={item.value}
                    onChange={e => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          value: e.target.value,
                        }) : i)),
                      },
                    })}
                  />
                </Col>
                {values.title.length > 1 && <Col sm={1}>
                  <Button
                    shape="circle" icon="close" onClick={() => this.setState({
                      values: {
                        ...values,
                        title: values.title.filter((_, idx) => idx !== index),
                      },
                    })}
                  />
                </Col>}
              </Row>
            ))}
            {(values.title.length < 3 || values.title.length > 45 ) && <Button
              icon="plus" type="dashed" onClick={() => this.setState({
                values: {
                  ...values,
                  title: [...values.title, { lang: '', value: '' }],
                },
              })}
            >Thêm ngôn ngữ</Button>}
          </Form.Item>
          <Form.Item label="Giá trị">
            <Input
              type="number"
              value={values.count}
              onChange={e => this.handleUpdateField('count', e.target.value)}
              placeholder="99"
            />
          </Form.Item>
          <Form.Item label="Màu nền">
            <Input
              value={values.color}
              onChange={e => this.handleUpdateField('color', e.target.value)}
              placeholder="#ffffff"
              style={{ backgroundColor: values.color }}
            />
          </Form.Item>
          <Form.Item label="Ưu tiên">
            <Input
              type="number"
              value={values.position}
              onChange={e => this.handleUpdateField('position', e.target.value)}
              placeholder="1"
            />
          </Form.Item>
        </Modal>
      </Fragment>
    );
  }
}

export default connect(state => ({
}), {
  createHomeStat,
  editHomeStat,
})(HomeStatModal);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/HomeStat/HomeStatModal.js